import React from "react";
import CopyIcon from "@atlaskit/icon/core/copy";
import { duplicateFlow } from "../../../common/factory/flow.factory";
import { useDispatch } from "react-redux";
import { saveFlow } from "../../../redux/actions/integrationActions";

import Button from "@atlaskit/button/new";

const DuplicateFlowMenuItem = ({ flow, onClickCallback }) => {

  const dispatch = useDispatch();
  
  const handleOnClick = () => {
    const duplicate = duplicateFlow(flow);
    dispatch(saveFlow(duplicate));
    onClickCallback();
  };

  return (
    <>
      <Button iconBefore={CopyIcon} appearance="subtle" onClick={handleOnClick}>
        Duplicate flow
      </Button>
    </>
  );
};
export default DuplicateFlowMenuItem;
